import { PropsWithClassName } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { Hash } from '../../hooks';
import { RichText } from '../../i18n';

type VATLegalMentionProps = PropsWithClassName & {
    isClickable?: boolean;
};

export const VATLegalMention: Component<VATLegalMentionProps> = ({ className, isClickable = true }) => {
    return (
        <RichText
            messageKey={
                isClickable
                    ? /* FIXME: These translations should be move in Common when it will be rework */
                      'Discover.Pdp.productInfo.label.deliveryInformation'
                    : 'Discover.Home.carousel.label.deliveryInformation'
            }
            fontSize={'bodySmall'}
            links={{ link: { href: Hash.DeliveryReturnsModal } }}
            className={className}
        />
    );
};
